import { GraphQlClient } from '@intelipost-js/secure-providers';
import {
  ScToast,
} from '@intelipost-js/secure-components';

export default {
  getTableGereratedQuoteContract({ commit }, params) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
    query(
      $contract_id: Int!,
    ) {
      logisticContractInfo(
        contract_id: $contract_id
      ) {
        id
        zip_code_start
        zip_code_end
        file_name
        valid_from
      }
    }`, params)
      .then(res => res.data);
  },
  getLogisticContract({ commit }, params) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
    query(
      $contract_id: Int!,
    ) {
      logisticContractInfo(
        contract_id: $contract_id
      ) {
        id
        zip_code_start
        zip_code_end
        file_name
        valid_from
      }
    }`, params)
      .then(res => res.data);
  },
  getDeliveryMethod({ commit }, id) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
      query ($id: Int!) {
        deliveryMethod(id: $id) {
          id
          name
          logo_url
          enabled
        }
      }`, { id })
      .then(({ data }) => {
        const { deliveryMethod } = data || {};

        commit('toggleLoading', false);
        commit('setDeliveryMethod', deliveryMethod);
      })
      .catch(() => commit('toggleLoading', false));
  },
  getContractData({ commit }, params) {
    commit('setContracts', []);
    commit('toggleLoading', true);

    return GraphQlClient.query(`
    query(
      $contract_id: Int!,
    ) {
      logisticContractData(
        contract_id: $contract_id
      ) {
        id
        zip_code_start
        zip_code_end
        logistic_contract_id
        minimum_total_freight
        delivery_time
        collect_time
        destination_geo_identifier
      }
    }`, params)
      .then((res) => {
        const { logisticContractData } = res.data;

        commit('setContractData', logisticContractData);
        commit('toggleLoading', false);
        return logisticContractData;
      });
  },
  setContractData({ commit }, params) {
    commit('toggleLoading', true);
    return GraphQlClient.mutation(`
    mutation (
      $contract_id: Int!,
      $contracts: [ContractDataFields]!,
    ) {
      setLogisticContractData (
        contract_id: $contract_id,
        contracts: $contracts
      ) {
        ok
      }
    }`, params)
      .then(() => {
        commit('toggleLoading', false);
      });
  },
  setUpdateLogisticContractInfo({ commit }, params) {
    commit('toggleLoading', true);
    return GraphQlClient.mutation(`
    mutation (
      $contract_id: Int!,
      $zip_code_start: Int,
      $zip_code_end: Int,
      $file_name: String,
      $valid_from: String
    ) {
      setUpdateLogisticContractInfo (
        contract_id: $contract_id,
        zip_code_start: $zip_code_start,
        zip_code_end: $zip_code_end,
        file_name: $file_name,
        valid_from: $valid_from
      ) {
        ok
      }
    }`, params)
      .then(() => {
        ScToast.success('Atualização realizada com sucesso!');
        commit('toggleLoading', false);
      });
  },
  getLogisticProviders({ commit }, active = false) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
    query($active: Boolean) {
      logisticProviders(active: $active) {
        id
        name
        delivery_methods {
          id
          name
          logo_url
          enabled
          pending_contracts
          type
        }
      }
    }`, { active })
      .then(({ data = {} }) => {
        commit('toggleLoading', false);
        const { logisticProviders = [] } = data;

        commit('setLogisticProviders', logisticProviders);
        return Promise.resolve(logisticProviders);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  sendGenerateTableContract({ commit }, { id }) {
    commit('toggleLoading', true);

    const params = {
      id,
    };

    return GraphQlClient.mutation(`
    mutation($id: Int!) {
      sendGenerateTableContract(id: $id) {
        id
      }
    }`, params)
      .then((res) => {
        commit('toggleLoading', false);
        /* const message = enabled ? 'habilitado' : 'desabilitado';
        ScToast.success(`Método de envio ${message} com sucesso`); */
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  setEnabledDeliveryMethod({ commit }, { id, enabled }) {
    commit('toggleLoading', true);

    const params = {
      id,
      enabled,
    };

    return GraphQlClient.mutation(`
    mutation($id: Int!, $enabled: Boolean!) {
      setEnabledDeliveryMethod(id: $id, enabled: $enabled) {
        id
      }
    }`, params)
      .then((res) => {
        commit('toggleLoading', false);
        const message = enabled ? 'habilitado' : 'desabilitado';
        ScToast.success(`Método de envio ${message} com sucesso`);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  contestContractDeliveryMethod({ commit }, params) {
    return GraphQlClient.mutation(`
    mutation (
      $id: Int!,
      $contractMessage: String!,
    ) {
      contestLogisticProviderDeliveryMethodContracts (
        id: $id,
        contractMessage: $contractMessage
      ) {
        ok
      }
    }`, params);
  },
  sendContractToApproval({ commit }, params) {
    return GraphQlClient.mutation(`
    mutation (
      $id: Int!,
      $contractMessage: String!,
    ) {
      sendLogisticProviderDeliveryMethodContractsToApproval (
        id: $id,
        contractMessage: $contractMessage
      ) {
        ok
      }
    }`, params);
  },
  sendContractToLive({ commit }, params) {
    return GraphQlClient.mutation(`
    mutation (
      $id: Int!,
    ) {
      sendLogisticProviderDeliveryMethodContractsToLive (
        id: $id,
      ) {
        ok
      }
    }`, params);
  },
  sendContractToDraft({ commit }, params) {
    commit('toggleLoading', true);
    return GraphQlClient.mutation(`
    mutation (
      $id: Int!,
    ) {
      sendLogisticProviderDeliveryMethodContractsToDraft (
        id: $id,
      ) {
        ok
      }
    }`, params);
  },
  approveContract({ commit }, params) {
    return GraphQlClient.mutation(`
    mutation (
      $id: Int!,
    ) {
      approveLogisticProviderDeliveryMethodContracts (
        id: $id,
      ) {
        ok
      }
    }`, params);
  },
  deleteContract({ commit }, params) {
    return GraphQlClient.mutation(`
    mutation (
      $id: Int!,
    ) {
      deleteLogisticProviderDeliveryMethodContracts (
        id: $id,
      ) {
        ok
      }
    }`, params);
  },
  lockContract({ commit }, params) {
    return GraphQlClient.mutation(`
    mutation (
      $id: Int!,
    ) {
      lockLogisticProviderDeliveryMethodContracts (
        id: $id,
      ) {
        ok
      }
    }`, params);
  },
  unLockContract({ commit }, params) {
    return GraphQlClient.mutation(`
    mutation (
      $id: Int!,
    ) {
      unLockLogisticProviderDeliveryMethodContracts (
        id: $id,
      ) {
        ok
      }
    }`, params);
  },
  getLogisticProviderDeliveryMethodContracts({ commit }, params) {
    commit('setContracts', []);
    commit('toggleLoading', true);

    return GraphQlClient.query(`
    query(
      $id: Int!,
      $delivery_method_id: Int!,
      $contract_id: Int!,
    ) {
      logisticProviderDeliveryMethodContracts(
        id: $id,
        delivery_method_id: $delivery_method_id
        contract_id: $contract_id
      ) {
        delivery_method{
          current_contracts{
            id
            file_name
            origin_zip_code_start
            origin_zip_code_end
            valid_from
            valid_to
            modified
            is_in_edition
            edition_user_name
            edition_user_id
            is_edition_owner
          }
          history_contracts{
            id
            file_name
            origin_zip_code_start
            origin_zip_code_end
            valid_from
            valid_to
            modified
            is_in_edition
            edition_user_name
            edition_user_id
            is_edition_owner
          }
          draft_contracts{
            id
            file_name
            origin_zip_code_start
            origin_zip_code_end
            valid_from
            valid_to
            modified
            status
            is_in_edition
            edition_user_name
            edition_user_id
            is_edition_owner
          }
          contested_contracts{
            id
            file_name
            origin_zip_code_start
            origin_zip_code_end
            valid_from
            valid_to
            modified
            status
            is_in_edition
            edition_user_name
            edition_user_id
            is_edition_owner
          }
          detailed_contracts{
            id
            file_name
            origin_zip_code_start
            origin_zip_code_end
            valid_from
            valid_to
            modified
            status
            is_in_edition
            edition_user_name
            edition_user_id
            is_edition_owner
          }
        }
      }
    }`, params)
      .then((res) => {
        const { data = {} } = res || {};
        const { logisticProviderDeliveryMethodContracts } = data;
        const { delivery_method } = logisticProviderDeliveryMethodContracts;

        commit('setContracts', delivery_method);
        commit('toggleLoading', false);
      });
  },
  getContractLogs({ commit }, params) {
    commit('setContracts', []);
    commit('toggleLoading', true);

    return GraphQlClient.query(`
    query (
      $contract_id: Int!
    ) {
      contractLogs(
        contract_id: $contract_id
      ) {
        to_mode_id
        from_status_id
        to_status_id
        created_iso
        message
        user_name
      }
    }`, params)
      .then((res) => {
        const { data = {} } = res || {};
        const { contractLogs } = data;

        commit('setContractLogs', contractLogs);
        commit('toggleLoading', false);
      });
  },
  getOverlapContract({ commit }, args = {}) {
    commit('toggleLoading', true);
    return GraphQlClient.query(
      `query(
        $id: Int!,
        ){
          overlapLogisticProviderDeliveryMethodContracts(
          id: $id,
        ){
          id,
          file_name,
          is_in_edition,
        }
      }`, args)
    .then((res) => {
      const {
        data,
      } = res;
      const {
        overlapLogisticProviderDeliveryMethodContracts,
      } = data;
      commit('setOverlapContract', overlapLogisticProviderDeliveryMethodContracts);
      commit('toggleLoading', false);
    })
    .catch((err) => {
      commit('toggleLoading', false);
      return Promise.reject(err);
    });
  },
  getLogisticProviderWithOneDeliveryMethod({ commit }, params) {
    commit('setLogisticProvider', {});
    commit('toggleLoading', true);

    return GraphQlClient.query(`
    query(
      $id: Int!,
      $delivery_method_id: Int!,
    ) {
      logisticProviderWithOneDeliveryMethod(
        id: $id,
        delivery_method_id: $delivery_method_id
      ) {
        id
        delivery_method{
          id
          config {
            groups {
              id
              name
              fields {
                id
                label
                value
                example
                type
                rule
                mask
                required
                disabled
                options {
                  label
                  value
                }
              }
            }
          }
        }
      }
    }`, params)
      .then((res) => {
        const { data = {} } = res || {};
        const { logisticProviderWithOneDeliveryMethod = {} } = data;

        commit('toggleLoading', false);
        commit('setLogisticProvider', logisticProviderWithOneDeliveryMethod);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  saveLogisticProviderWithOneDeliveryMethod({ commit, state }, model) {
    commit('toggleLoading', true);

    const {
      delivery_method = {},
    } = state.logisticProvider;
    const {
      id: delivery_method_id,
      config: { groups = [] },
    } = delivery_method || {};

    const newGroups = groups.map(group => ({
      id: group.id,
      fields: group.fields.map(field => ({
        id: field.id,
        value: model[field.id],
      })),
    }));

    const data = {
      delivery_method_id,
      groups: newGroups,
    };

    return GraphQlClient.mutation(`
    mutation (
      $delivery_method_id: Int!,
      $groups: [DeliveryMethodGroups]!,
    ) {
      saveLogisticProviderWithOneDeliveryMethod (
        delivery_method_id: $delivery_method_id,
        groups: $groups,
      ) {
        id
      }
    }`, data)
      .then((res) => {
        commit('toggleLoading', false);
        ScToast.success('Dados atualizados com sucesso.');
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  updateSigep({ commit }, args) {
    const {
      id,
      delivery_method_id,
    } = args || {};

    commit('toggleLoading', true);
    GraphQlClient.mutation(`
    mutation(
      $id: Int!,
      $delivery_method_id: Int!,
    ) {
      updateSigep(
        id: $id,
        delivery_method_id: $delivery_method_id
      ) {
        ok
      }
    }`, {
      id,
      delivery_method_id,
    })
      .then((res) => {
        commit('toggleLoading', false);
        ScToast.success('Seus dados do Sigep foram validados e serão atualizados na Intelipost.');
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./src/stores/logistic-providers/actions.js